import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=5f5af1e1&scoped=true"
import script from "./contract.vue?vue&type=script&lang=js"
export * from "./contract.vue?vue&type=script&lang=js"
import style0 from "./contract.vue?vue&type=style&index=0&id=5f5af1e1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5af1e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f5af1e1')) {
      api.createRecord('5f5af1e1', component.options)
    } else {
      api.reload('5f5af1e1', component.options)
    }
    module.hot.accept("./contract.vue?vue&type=template&id=5f5af1e1&scoped=true", function () {
      api.rerender('5f5af1e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/components/contract.vue"
export default component.exports